import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HttpInterceptorService } from '@core/interceptors/http.interceptor';
import { NgOptimizedImage, TitleCasePipe } from '@angular/common';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { StoreModule } from '@ngrx/store';
import { MsalGuard, MsalInterceptor, MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { environment } from '@environments/environment';
import { authReducer } from './store/auth.reducer';
import { adminReducer } from './store/admin.reducer';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from './shared/shared.module';
import { NetworkErrorComponent } from './shared/components/network-error/network-error.component';
import { ServerErrorComponent } from './shared/components/server-error/server-error.component';
import { MatIconModule } from '@angular/material/icon';

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

@NgModule({
	declarations: [AppComponent, NetworkErrorComponent, ServerErrorComponent],
	imports: [
		MatIconModule,
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		NgOptimizedImage,
		StoreModule.forRoot({ auth: authReducer, admin: adminReducer }),
		MsalModule.forRoot(
			new PublicClientApplication({
				auth: {
					clientId: environment.SSO_CONFIG.CLIENT_ID,
					authority: environment.SSO_CONFIG.AUTHORITY + environment.SSO_CONFIG.TENANT_ID + '/',
					redirectUri: environment.SSO_CONFIG.REDIRECT_URL,
				},
				cache: {
					cacheLocation: 'localStorage',
					storeAuthStateInCookie: isIE,
				},
			}),
			{
				interactionType: InteractionType.Redirect,
				authRequest: {
					scopes: ['openid', 'profile', 'user.read'],
				},
			},
			{
				interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
				protectedResourceMap: new Map([['https://graph.microsoft.com/v1.0/me', ['user.read']]]),
			}
		),
		NgxSpinnerModule,
		SharedModule,
	],
	providers: [
		TitleCasePipe,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: MsalInterceptor,
			multi: true,
		},
		MsalGuard,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpInterceptorService,
			multi: true,
		},
		provideAnimationsAsync(),
	],
	bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {}
